import { render, staticRenderFns } from "./VideoCarouselItem.vue?vue&type=template&id=2b6a9f99"
import script from "./VideoCarouselItem.vue?vue&type=script&lang=js"
export * from "./VideoCarouselItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../shared/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports